/**
 * Persian relative time helpers (last login, calc_date, etc.).
 * Digit shapes follow the global numeral system setting.
 */

import {
  formatDateTime,
  localizeDigits,
} from "./numberLocale";

function toDate(value) {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

/**
 * Relative time (dashboard calc_date, etc.).
 * @param {string|Date|null|undefined} input
 * @returns {string|null}
 */
export function formatRelativeFa(input) {
  if (!input) return null;
  const date = toDate(input);
  if (!date) return null;

  const diffMs = Date.now() - date.getTime();
  if (diffMs < 0) {
    return formatDateTime(date);
  }

  const mins = Math.floor(diffMs / 60000);
  if (mins < 1) return "همین الان";
  if (mins < 60) return `${localizeDigits(mins)} دقیقه پیش`;

  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${localizeDigits(hours)} ساعت پیش`;

  const days = Math.floor(hours / 24);
  if (days < 7) return `${localizeDigits(days)} روز پیش`;
  if (days < 30) {
    const weeks = Math.floor(days / 7);
    return `${localizeDigits(weeks)} هفته پیش`;
  }

  return formatDateTime(date);
}

/**
 * Absolute datetime for tooltip/title.
 * @param {string|Date|null|undefined} input
 * @returns {string}
 */
export function formatAbsoluteFa(input) {
  const date = toDate(input);
  if (!date) return "";
  return formatDateTime(date);
}

/**
 * Relative time for last-login style labels (staff list).
 * @param {string|Date|null|undefined} value
 * @param {Date} [now]
 * @returns {string}
 */
export function formatRelativeTimeFa(value, now = new Date()) {
  const date = toDate(value);
  if (!date) return "";

  const diffMs = Math.max(0, now.getTime() - date.getTime());
  const minutes = Math.floor(diffMs / 60000);
  const hours = Math.floor(diffMs / 3600000);
  const days = Math.floor(diffMs / 86400000);

  if (minutes < 1) return "همین الان";
  if (minutes < 60) return `${localizeDigits(minutes)} دقیقه پیش`;
  if (hours < 24) return `${localizeDigits(hours)} ساعت پیش`;
  if (days < 30) return `${localizeDigits(days)} روز پیش`;

  const months = Math.floor(days / 30);
  if (months < 12) return `${localizeDigits(months)} ماه پیش`;

  const years = Math.floor(days / 365);
  return `${localizeDigits(years)} سال پیش`;
}
